import { Scenarios } from '@jfs/network'

const getConvenienceFeeApi = {
  default: [
    {
      url: /convenienceFee/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        entity: { initiatingEntityId: 8030, application: 8030, type: 12, entityId: '100002000003382' },
        feeDetails: [
          {
            method: { type: '309', subType: '550' },
            card: { cardBin: '*', scheme: null, type: null },
            fee: {
              feeAttributes: [{ type: 2, value: 1.0, minimumAmount: 0.0, maximumAmount: 5000.0 }],
              totalConvenienceFee: 2.54,
              feeTax: { cgst: 0.23, sgst: 0.23, igst: 0.0, ugst: 0.0, tcs: null, tds: 0.0 },
              merchantShare: 'N',
            },
          },
        ],
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /convenienceFee/,
      method: 'POST',
      responseCode: 501,
      response: { status: 'FAILURE', error: { code: '33607', message: 'INVALID.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getConvenienceFeeApi }
